/* DSL Color-mode auto-sync system preference */
(function(){
  if (!window.matchMedia) return;
  var mq = window.matchMedia("(prefers-color-scheme: dark)");
  function update(){
    var t = (function(){ try { return localStorage.getItem("dsl_theme"); } catch(e){ return null; } })() || "auto";
    if (t === "auto") {
      document.documentElement.dataset.theme = mq.matches ? "dark" : "light";
    }
  }
  mq.addEventListener("change", update);
  update();
})();